import { WsDecodeProfile } from '../../core/src/interfaces';
import { WsDecodeClassification } from './enums';




const getProfileList = (): WsDecodeProfile[] => {

  return [
    {
      id: 'USER',
      name: 'User',
      type: WsDecodeClassification.User,
      primaryIdentifier: 'user_id',
      identifierValue: '1'
    },
    {
      id: 'DEVICE',
      name: 'Device',
      type: WsDecodeClassification.Device,
      primaryIdentifier: 'device_id',
      identifierValue: '0000000001'
    },
    {
      id: 'APPLICATION',
      name: 'Application',
      type: WsDecodeClassification.Application,
      primaryIdentifier: 'app_id',
      identifierValue: 'ms_teams'
    },

    // Executive
    // OfficeWorker
    // Developer
    // RemoteWorker

    // {
    //   id: 'APPLICATION',
    //   name: 'Application',
    //   type: WsDecodeClassification.Application,
    //   primaryIdentifier: 'app_id',
    //   identifierValue: 'ms_teams'
    // }
  ];

}




export {
  getProfileList
};
